import React from 'react';
import Tag from '../../../../components/Display/Tag';
import moment from 'moment';
import { getConstant } from '../../../../utils/constants';

function EventItem({ event, handleClickEvent }) {
  return (
    <div className="flex flex-row items-center py-5 px-3 gap-x-5 shadow-xl  h-44 ">
      <div
        className={`flex flex-row items-center py-5 px-3 gap-x-5   w-full h-44 ${
          handleClickEvent && 'cursor-pointer hover:bg-slate-100'
        }`}
        onClick={handleClickEvent || undefined}>
        <div className="flex flex-col justify-around h-full w-full">
          <div className="flex flex-col gap-y-1">
            <div className="text-xl font-bold text-slate-700 ">{event.title}</div>
            <div className="text-sm text-slate-700 ">{event.place}</div>

            <div className="flex flex-row gap-1">
              <span className="font-medium text-slate-700">
                {moment(event.start_dt).format('LLL')}
              </span>
              {'-'}
              <span className="font-medium text-slate-700">
                {moment(event.end_dt).format('LLL')}
              </span>
            </div>
          </div>
          <div className="flex flex-row gap-x-3">
            <Tag
              tag={{
                label: getConstant('solarys.formatList', event.format).label,
                icon: 'shape',
                bgColor: 'bg-blue-500'
              }}
            />
            {event.public_list.map((o, key) => (
              <Tag
                key={key}
                tag={{
                  label: o.label,
                  icon: 'man',
                  bgColor: 'bg-yellow-500'
                }}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default EventItem;
